"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.VideoPlaySVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var VideoPlaySVG = function VideoPlaySVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM17,6h2V9H17ZM13,6h2V9H13ZM7,26H5V23H7ZM7,9H5V6H7Zm4,17H9V23h2ZM11,9H9V6h2Zm4,17H13V23h2Zm4,0H17V23h2Zm.51-9-6.06,3.91A.9.9,0,0,1,13,21a.91.91,0,0,1-.49-.15,1.12,1.12,0,0,1-.48-1V12.1a1.12,1.12,0,0,1,.48-.95.88.88,0,0,1,1,0l6.06,3.91a1.17,1.17,0,0,1,0,1.9ZM23,26H21V23h2ZM23,9H21V6h2Zm4,17H25V23h2ZM27,9H25V6h2Z"
  }));
};
exports.VideoPlaySVG = VideoPlaySVG;
VideoPlaySVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(VideoPlaySVG);
exports.default = _default;